const DEFAULT_AUTH_API_URL = "http://localhost:8080";

// Determina si estamos en desarrollo o producción
const isDevelopment = process.env.NODE_ENV === 'development' || 
                      window.location.hostname === 'localhost' || 
                      window.location.hostname === '127.0.0.1';

// Lee primero de window.env (dinámico, útil para producción sin rebuild)
// Luego de process.env (útil para desarrollo con archivos .env)
// Finalmente usa el default
const getAuthApiUrl = () => {
  // En desarrollo, usa rutas relativas (proxy)
  if (isDevelopment) {
    return ''; // Ruta relativa, el proxy la manejará
  }
  
  // En producción, usa la URL completa
  const raw =
    (typeof window !== 'undefined' && window.env?.REACT_APP_AUTH_API_URL) ||
    (typeof window !== 'undefined' && window.env?.REACT_APP_API_URL) ||
    process.env.REACT_APP_AUTH_API_URL ||
    process.env.REACT_APP_API_URL ||
    DEFAULT_AUTH_API_URL;
  return raw.endsWith("/") ? raw.slice(0, -1) : raw;
};

const AUTH_API_URL = getAuthApiUrl();

export const authenticationService = {
    login,
    logout,
    checkSessionValidity,
    cambiarPassword
};

async function login(username, password) {
    const response = await fetch(`${AUTH_API_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': '*/*'
        },
        body: JSON.stringify({ username, password })
    });

    if (!response.ok) {
        throw new Error('No se pudo iniciar sesión');
    }

    const result = await response.json();
    persistSession(result);
    return result;
}

async function logout() {
    const token = localStorage.getItem("token");

    try {
        if (token) {
            await fetch(`${AUTH_API_URL}/api/auth/logout`, {
                method: 'POST',
                headers: {
                    'Accept': '*/*',
                    'Authorization': `Bearer ${token}`
                }
            });
        }
    } catch (error) {
        console.warn('No se pudo cerrar sesión en el servidor', error);
    } finally {
        clearSession();
    }
}

function checkSessionValidity() {
    const sessionRaw = localStorage.getItem("session");
    if (!sessionRaw) {
        return false;
    }

    try {
        const session = JSON.parse(sessionRaw);
        if (!session?.token) {
            clearSession();
            return false;
        }

        if (session.expirationTime && Date.now() > session.expirationTime) {
            clearSession();
            return false;
        }

        return true;
    } catch (error) {
        clearSession();
        return false;
    }
}

function persistSession(payload) {
    if (!payload?.token) {
        return;
    }
    localStorage.setItem("token", payload.token);
    localStorage.setItem("session", JSON.stringify(payload));
}

function clearSession() {
    localStorage.removeItem("token");
    localStorage.removeItem("session");
}

async function cambiarPassword(passwordActual, passwordNueva) {
    const token = localStorage.getItem("token");
    
    const response = await fetch(`${AUTH_API_URL}/api/auth/cambiar-password`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': '*/*',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ passwordActual, passwordNueva })
    });

    if (!response.ok) {
        if (response.status === 400) {
            throw new Error('La contraseña actual es incorrecta');
        }
        throw new Error('Error al cambiar la contraseña');
    }

    try {
        return await response.json();
    } catch {
        return { ok: true };
    }
}
